import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { VorComponent } from './vor-lista/vor.component';
import { VorService } from './vor.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  imports: [
    ComumModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    NgbModule,
    DialogModule,
    TableModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    InputTextareaModule,
    TreeTableModule,
    TranslateModule.forRoot(translateLoaderNBS),
    OsModule,
    MultiSelectModule,
    CalendarModule
  ],
  exports: [
    VorComponent
  ],
  declarations: [
    VorComponent
  ],
  providers: [
    CurrencyPipe,
    VorService,
    DatePipe
  ]
})
export class VorModule { }
